import React, { PropsWithChildren } from "react";
import { Container } from "react-bootstrap";

type Props = {
  header?: string;
};

const Card = (props: PropsWithChildren<Props>) => {
  const { header, children } = props;

  return (
    <Container className="p-0">
      <section className="card">
        <Container>{header && <h1>{header}</h1>}</Container>
        {children}
      </section>
    </Container>
  );
};

export default Card;
